import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TOP_BAR_MODULE_REGION_ID, TOP_BAR_MODULE_ACTIVE_EVALUATION_ID } from '@ontruck/fe-core';
import { ButtonComponent, FlexComponent } from '@ontruck/fe-ui';
import { IconComponent } from '@ontruck/fe-icons';
import { MenuIcon } from '../../assets/icons/icon_by_config/TopBarMenuIcon';
import { Flexer } from '@ontruck/orc';
import { toggleModal } from 'redux/modules/shipper-order-new/effects';
import { StyledLogo, StyledTopBar } from './styled';
import { getClientConfig, constants } from 'redux/modules/client-config/selectors';
import Menu from './Menu';
import Submenu from './Submenu';
import { useTopBarMenuButtonStateHook } from 'components/Topbar/providers/top-bar-menu-button-state-hook';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import { TOP_BAR_MODULE_MY_DELEGATION_ID } from '@ontruck/fe-ontime';

const TopBarMenuButton = styled(ButtonComponent)`
  height: 59px;
  width: 60px;
  padding-right: 10px;
  padding-left: 10px;
`;

const Topbar = ({ history: { push }, toggleModal }) => {
  const menuIconSrc = MenuIcon();
  const { toggle: toggleLeftSidebarState } = useTopBarMenuButtonStateHook();

  let TOP_BAR_MENU_BUTTON_ENABLED_CONFIG = useSelector((store) =>
    getClientConfig(store, constants.TOP_BAR_MENU_BUTTON_ENABLED)
  );

  let TOP_BAR_MODULE_REGION_ENABLED_CONFIG = useSelector((store) =>
    getClientConfig(store, constants.TOP_BAR_MODULE_REGION_ENABLED)
  );

  let TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED_CONFIG = useSelector((store) =>
    getClientConfig(store, constants.TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED)
  );

  let TOP_BAR_MENU_BUTTON_ENABLED =
    TOP_BAR_MENU_BUTTON_ENABLED_CONFIG[constants.TOP_BAR_MENU_BUTTON_ENABLED];

  let TOP_BAR_MODULE_REGION_ENABLED =
    TOP_BAR_MODULE_REGION_ENABLED_CONFIG[constants.TOP_BAR_MODULE_REGION_ENABLED];

  let TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED =
    TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED_CONFIG[
      constants.TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED
    ];

  // TODO: CEX, remove only test - Enable top bar menu button
  TOP_BAR_MENU_BUTTON_ENABLED = getTenantPreLoginConfig().company_name === 'Correos Express';
  TOP_BAR_MODULE_REGION_ENABLED = getTenantPreLoginConfig().company_name === 'Correos Express';
  TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED =
    getTenantPreLoginConfig().company_name === 'Correos Express';

  const TOP_BAR_MODULE_MY_DELEGATION_ENABLED = getTenantPreLoginConfig().company_name === 'Ontime';

  return (
    <StyledTopBar>
      <Flexer.Child>
        <FlexComponent>
          {TOP_BAR_MENU_BUTTON_ENABLED ? (
            <TopBarMenuButton color="primary" onClick={toggleLeftSidebarState}>
              <IconComponent name="menu" colorVariant="primary" size="xl" />
            </TopBarMenuButton>
          ) : null}
          <StyledLogo alt="TMS" src={menuIconSrc} />
        </FlexComponent>
      </Flexer.Child>
      {TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED ? (
        <section id={TOP_BAR_MODULE_ACTIVE_EVALUATION_ID}></section>
      ) : null}
      <Flexer.Child flex="1">
        <Menu />
      </Flexer.Child>
      {TOP_BAR_MODULE_REGION_ENABLED && TOP_BAR_MODULE_REGION_ID ? (
        <Flexer.Child>
          <section id={TOP_BAR_MODULE_REGION_ID}></section>
        </Flexer.Child>
      ) : null}
      {TOP_BAR_MODULE_MY_DELEGATION_ENABLED ? (
        <Flexer.Child>
          <section id={TOP_BAR_MODULE_MY_DELEGATION_ID}></section>
        </Flexer.Child>
      ) : null}
      <Flexer.Child>
        <Submenu onChangeSection={push} toggleModal={toggleModal} />
      </Flexer.Child>
    </StyledTopBar>
  );
};

Topbar.propTypes = {
  push: PropTypes.func,
  toggleModal: PropTypes.func.isRequired,
};

export default withRouter(
  injectIntl(
    connect(null, {
      toggleModal,
    })(Topbar)
  )
);
